module.exports = __webpack_public_path__ + "img/filter-f.70d3dc5c.svg";